/**
 * @imports
 */
import React from 'react'
import { Button, Tooltip } from 'antd'

/**
 *
 * @param {*} props
 * @returns
 */
export function ComIngresarPeriodoEquipo(props) {
  return (
    <Tooltip title='Periodos para pago'>
      <Button
        type="ghost"
        icon='bank'
        size='small'
        onClick={props.onClick}
      />
    </Tooltip>
  )
}
